import DocusaurusFooter from '../DocusaurusFooter'
import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import { coverageHeatmap } from '../../docs-routes'

const CoverageHeatmap = () =>
  <>
    <Paragraph>
      <Color variant='theme-description-text'>
        The Coverage Heatmap visualizes the coverage percentages of states and actions within a model.
      </Color>
    </Paragraph>
    <DocusaurusFooter path={coverageHeatmap} />
  </>

export default CoverageHeatmap
